module.exports = __webpack_public_path__ + "static/img/3-info-b8.73fd071.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3-info-b8.jpg
// module id = ZA49
// module chunks = 0